"use client";
import { Stack, Typography, Button, Box } from "@mui/material";
import { HeroBanner } from "../hero_banner";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useRouter } from "next/navigation";

export function Hero() {
  const router = useRouter();

  const handleBrandQuualityClick = () => {
    router.push("/brand-quality");
  };

  const handleProductsClick = () => {
    router.push("/products");
  };

  return (
    <HeroBanner
      background="/images/home/hero_banner.png"
      video="https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fhero_video.mp4?alt=media&token=42437d55-6abd-48d8-aefb-7e8749a60272"
    >
      <Stack
        height="100%"
        width="100%"
        px={{
          xs: 4,
          md: 30,
        }}
        pb={{
          xs: 15,
          md: 30,
        }}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Stack
          height={{
            xs: "fit-content",
            md: "100%",
          }}
          width={{
            xs: "100%",
            md: "50%",
          }}
          justifyContent="center"
        >
          <Typography
            variant="h1"
            fontSize={{
              xs: "48px",
              md: "80px",
            }}
          >
            # ชีวิตดี๊ดี
          </Typography>
          <Typography
            variant="h1"
            fontSize={{
              xs: "48px",
              md: "80px",
            }}
          >
            เหมือนมี<span style={{ color: "#BC1918" }}>เชฟ</span>ที่บ้าน
          </Typography>
          <Typography
            variant="body1"
            fontSize={{
              xs: "18px",
              md: "24px",
            }}
            fontWeight={400}
            pt={7}
          >
            สุขใจทั้งผู้ให้ ถูกใจทั้งผู้รับ ปลาร้าเชฟไพรฑูรย์
          </Typography>
          <Stack
            direction="row"
            gap={4}
            mt={18}
            display={{
              xs: "none",
              md: "flex",
            }}
          >
            <Button variant="contained" onClick={handleProductsClick}>
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="button" color="textPrimary">
                  ผลิตภัณฑ์ทั้งหมด
                </Typography>
                <ArrowForwardRoundedIcon
                  style={{
                    color: "#fff",
                  }}
                />
              </Stack>
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleBrandQuualityClick}
            >
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="button" color="textPrimary">
                  คุณภาพของแบรนด์
                </Typography>
                <ArrowForwardRoundedIcon
                  style={{
                    color: "#fff",
                  }}
                />
              </Stack>
            </Button>
          </Stack>
        </Stack>
        <Stack
          height={{
            xs: "100%",
            md: "100%",
          }}
          width={{
            xs: "100%",
            md: "50%",
          }}
          justifyContent={{
            xs: "flex-start",
            md: "flex-end",
          }}
          alignItems={{
            xs: "flex-start",
            md: "flex-end",
          }}
          mt={{
            xs: 15,
            md: 0,
          }}
        >
          <Stack
            bgcolor="#FFFFFF0D"
            maxWidth="100%"
            width="387px"
            height="136px"
            borderRadius={4}
            sx={{
              backdropFilter: "blur(10px)",
            }}
            p={6}
            gap={2}
            position="relative"
            onClick={() => router.push("#home_certificate")}
          >
            <Box
              position="absolute"
              right={{
                xs: 16,
                md: -10,
              }}
              top={{
                xs: -20,
                md: -20,
              }}
            >
              <Image
                src="/images/home/product_01.png"
                width="70"
                height="70"
                alt=""
              />
            </Box>
            <Typography
              variant="body1"
              fontSize={{
                xs: "20px",
                md: "24px",
              }}
              fontWeight="600"
            >
              มุ่งมั่นพัฒนาอย่างไม่หยุดยั้ง
            </Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography
                variant="subtitle2"
                fontSize={{
                  xs: "14px",
                  md: "16px",
                }}
                fontWeight="400"
                mt={2}
              >
                ใส่ใจทุกขั้นตอนการผลิต <br />{" "}
                เพื่อให้ผู้บริโภคได้ทานสินค้าที่มีคุณภาพ
              </Typography>
              <Box
                display="flex"
                width={36}
                height={36}
                bgcolor="#17232B"
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
              >
                <Image src="/svg/arrow.svg" width="14" height="14" alt="" />
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          gap={4}
          display={{
            xs: "flex",
            md: "none",
          }}
        >
          <Button variant="contained" onClick={handleProductsClick}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="button" color="textPrimary">
                ผลิตภัณฑ์ทั้งหมด
              </Typography>
              <ArrowForwardRoundedIcon
                style={{
                  color: "#fff",
                }}
              />
            </Stack>
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleBrandQuualityClick}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="button" color="textPrimary">
                คุณภาพของแบรนด์
              </Typography>
              <ArrowForwardRoundedIcon
                style={{
                  color: "#fff",
                }}
              />
            </Stack>
          </Button>
        </Stack>
      </Stack>
    </HeroBanner>
  );
}
